import { useEffect } from "react";

import { hashEmail } from "@framework/ads/ads.utils";
import { useIdentity } from "@voxmedia/duet-context/context/auth-context";

declare global {
  interface Window {
    atsenvelopemodule?: {
      setAdditionalData?: (args: AtsArgs) => void;
    };
  }
}

interface AtsArgs {
  type: string;
  id: string[];
}

const LiveRamp = () => {
  const user = useIdentity();

  const sendHashedUserEmails = async (email: string) => {
    try {
      const { sha256, sha1 } = await hashEmail(email);
      const emailHashes = [sha256, sha1].filter((hash) => Boolean(hash));

      if (
        window.atsenvelopemodule &&
        window.atsenvelopemodule.setAdditionalData
      ) {
        window.atsenvelopemodule.setAdditionalData({
          type: "emailHashes",
          id: emailHashes,
        });
      }
    } catch (error) {
      console.warn("Failed to send hashed email for LiveRamp:", error);
    }
  };

  useEffect(() => {
    if (!user || !user.email) {
      return;
    }

    const handleEnvelopeReady = () => {
      void sendHashedUserEmails(user.email);
    };

    window.addEventListener("envelopeModuleReady", handleEnvelopeReady);

    return () => {
      window.removeEventListener("envelopeModuleReady", handleEnvelopeReady);
    };
  }, [user, user?.email]);

  return null;
};

export default LiveRamp;
